<template>
  <swiper
    loop
    :swiper_config="swiper_config"
    :swiper_events="swiper_events"
    :space_between="0"
    fade_effect
    has_pagination
    prev_btn_class="prev_btn"
    next_btn_class="next_btn"
    add_navigation_buttons
    class="main-slider nav_buttons_inside">
    <swiper-slide
      v-for="(slide, index) in get_slides"
      :key="`swiper-slide_${index}_${uid}`"
      class="main-slider__item">
      <lazy-image
        v-if="!index || slide_index_shown.includes(index)"
        :src="slide.img_src"
        cover_img
        class="main-slider__item-image"
        :class="{shadow: slide.add_shadow_to_slide_image}"
        :lazy_src="slide.lazy_src"
        :alt="`main-slide_${index}`"/>
      <img
        v-else
        :src="slide.img_src"
        class="main-slider__item-image thumb"
        :alt="`main-slide_${index}`"/>
      <div
        class="container main-slider__item-content"
        :class="{slider_item_active: index === active_slide_index}">
        <yellow-icon
          v-if="getIsMobile && slide.mobile_icon"
          class="main-slider__item-content_icon"
          :icon="slide.mobile_icon"
          alt="slide icon"
        />
        <div
          class="main-slider__item-title" :style="{color: slide.text_color}">
          <span v-for="row in slide.title_rows">{{ row.line }}</span>
        </div>
        <div class="main-slider__item-sub_title" :style="{color: slide.text_color}">
          {{ slide.sub_title }}
        </div>
        <div
          v-if="slide.href && slide.button_text"
          class="main-slider__item-link">
          <default-button
            :href="slide.href"
            :is_light="Boolean(slide.white_button_link)">
            {{ slide.button_text }}
          </default-button>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>

<script>
import MainSlideImageSlot from "../slots/MainSlideImageSlot.vue";
import DefaultButton from "../slots/DefaultButton.vue";
import SemicircleIcon from "../fill_svg/SemicircleIcon.vue";
import WaveIcon from "../fill_svg/WaveIcon.vue";
import WaveSmallerIcon from "../fill_svg/WaveSmallerIcon.vue";
import ChangeTextBlock from "../small_parts/ChangeTextBlock.vue";
import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import uid_mixin from "../../mixins/uid_mixin";
import LazyImage from "../small_parts/LazyImage.vue";
import DefaultTitle from "../small_parts/DefaultTitle.vue";
import {mapGetters} from "vuex";
import YellowIcon from "../small_parts/YellowIcon.vue";

export default {
  name: "MainSlide",
  mixins: [uid_mixin],
  components: {
    YellowIcon,
    DefaultTitle,
    LazyImage,
    SwiperSlide,
    Swiper,
    ChangeTextBlock,
    DefaultButton,
    MainSlideImageSlot,
    SemicircleIcon,
    WaveIcon,
    WaveSmallerIcon,
  },
  props: {
    /**props**/
    slider_autoplay_ms: {
      type: String,
      default: '',
      admin_type: 'number',
    },
    slides: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        img_src: {
          type: String,
          default: '/images/uploads-main-slide.jpeg',
          admin_type: 'image',
        },
        lazy_img_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        mobile_lazy_img_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
        title_rows: {
          type: Array,
          default: () => [],
          admin_type: 'array',
          array_values: {
            line: {
              type: String,
              default: '',
              admin_type: 'input',
            }
          }
        },
        sub_title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        mobile_icon: {
          type: String,
          default: '',
          admin_type: 'select',
          admin_data_values: [
            'going_up.svg', 'light_bulb.svg', 'line.svg', 'star.svg'
          ],
        },
        href: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        button_text: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        white_button_link: {
          type: Boolean,
          default: false,
          admin_type: 'checkbox',
        },
        add_shadow_to_slide_image: {
          type: Boolean,
          default: true,
          admin_type: 'checkbox',
        },
        text_color: {
          type: Boolean,
          default: '',
          admin_type: 'input',
        },
      }
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    swiper_autoplay() {
      return !Number(this.slider_autoplay_ms) ? 5000 : Number(this.slider_autoplay_ms)
    },
    get_slides() {
      return this.slides.map(el => {
        el.lazy_src = this.getIsMobile && el.mobile_lazy_img_src ? el.mobile_lazy_img_src : el.lazy_img_src
        return el
      })
    },
    swiper_config() {
      return {
        speed: 600,
        touchStartForcePreventDefault: true,
        autoplay: {
          delay: this.swiper_autoplay,
          disableOnInteraction: true
        },
      }
    },
    swiper_events() {
      return {
        realIndexChange: this.slideChanged,
        // transitionEnd: this.slideChanged,
        // slideChangeTransitionEnd: this.slideChanged
      }
    }
  },
  data() {
    return {
      active_slide_index: 0,
      slide_index_shown: [0],
    }
  },
  methods: {
    slideChanged({realIndex = 0}) {
      if (this.active_slide_index === realIndex) return
      this.active_slide_index = realIndex
      if (this.slide_index_shown.includes(realIndex)) return;
      this.slide_index_shown.push(realIndex)
    }
  }
}
</script>
